/* App 下载页交互：问答手风琴、视频播放/暂停、商品卡配色换图。
   单独一个文件而不是并入 comu-sections.js——那个每页都加载，这三段只有本页用。 */
(function () {
  'use strict';

  /* ---------------------------------------------------------------
     问答手风琴
     设计稿是「单开」：点开一条会关掉其它所有条，由 data-single 控制。
     展开动画走 CSS 的 grid-template-rows 0fr→1fr，这里只切 class。 */
  function initFaq(root) {
    if (root.dataset.comuFaqBound === '1') return;
    root.dataset.comuFaqBound = '1';

    var single = root.getAttribute('data-single') === '1';
    var items = root.querySelectorAll('[data-comu-faq-item]');

    Array.prototype.forEach.call(items, function (item) {
      var btn = item.querySelector('[data-comu-faq-btn]');
      if (!btn) return;

      btn.addEventListener('click', function () {
        var willOpen = !item.classList.contains('open');

        if (single) {
          Array.prototype.forEach.call(items, function (other) {
            other.classList.remove('open');
            var ob = other.querySelector('[data-comu-faq-btn]');
            if (ob) ob.setAttribute('aria-expanded', 'false');
          });
        }

        item.classList.toggle('open', willOpen);
        btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      });
    });
  }

  /* ---------------------------------------------------------------
     视频播放 / 暂停
     关掉自动播放时视频的地址放在 data-src、preload="none"，
     第一次点击才写进 src——否则「不自动播」只是不播，6MB 照样先下下来。 */
  function initVideoShowcase(root) {
    if (root.dataset.comuVsBound === '1') return;
    root.dataset.comuVsBound = '1';

    var video = root.querySelector('[data-comu-vs-video]');
    var btn = root.querySelector('[data-comu-vs-toggle]');
    if (!video || !btn) return;

    function sync() {
      btn.classList.toggle('is-playing', !video.paused);
    }

    function toggle() {
      if (!video.getAttribute('src') && video.dataset.src) {
        video.setAttribute('src', video.dataset.src);
      }
      if (video.paused) {
        var p = video.play();
        if (p && p.catch) p.catch(function () { /* 自动播被浏览器挡下时保持暂停态 */ });
      } else {
        video.pause();
      }
    }

    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      toggle();
    });

    // 整块画面可点，和设计稿的 cursor: pointer 对应
    root.addEventListener('click', toggle);

    video.addEventListener('play', sync);
    video.addEventListener('pause', sync);
    sync();
  }

  /* ---------------------------------------------------------------
     商品卡配色换图 */
  function initProductCard(card) {
    if (card.dataset.comuPcBound === '1') return;
    card.dataset.comuPcBound = '1';

    var img = card.querySelector('[data-comu-pc-img]');
    if (!img) return;

    Array.prototype.forEach.call(card.querySelectorAll('[data-comu-pc-color]'), function (input) {
      input.addEventListener('change', function () {
        // 换色要同时换两样东西：主图，以及加购按钮指向的变体
        var vid = input.getAttribute('data-variant-id');
        if (vid) {
          Array.prototype.forEach.call(card.querySelectorAll('[data-comu-pc-action]'), function (btn) {
            btn.setAttribute('data-variant-id', vid);
          });
        }

        var src = input.getAttribute('data-img');
        if (!src) return;
        img.setAttribute('src', src);
        // srcset 不清掉的话浏览器会继续用旧图的候选集，换色看起来没反应
        var small = input.getAttribute('data-img-2x');
        if (small) {
          img.setAttribute('srcset', small + ' 400w, ' + src + ' 800w');
        } else {
          img.removeAttribute('srcset');
        }
      });
    });

    initCardActions(card);
  }

  /* ---------------------------------------------------------------
     商品卡的加购 / 立即购买

     加购走主题自己的事件链（cart:prepare-bundled-sections → variant:add →
     cart:change），不自己写抽屉逻辑——购物车有 drawer 和 popover 两种模式，
     自己实现必然和其中一种对不上。这套写法与 comu-sticky-bar.js 一致，已在线上验证过。 */
  function initCardActions(card) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    Array.prototype.forEach.call(card.querySelectorAll('[data-comu-pc-action]'), function (btn) {
      btn.addEventListener('click', function () {
        var action = btn.getAttribute('data-comu-pc-action');
        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId || btn.getAttribute('aria-busy') === 'true') return;

        btn.setAttribute('aria-busy', 'true');

        var sections = ['variant-added'];
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:prepare-bundled-sections', {
            bubbles: true,
            detail: { sections: sections }
          })
        );

        var body = new FormData();
        body.set('id', variantId);
        body.set('quantity', 1);
        body.set('sections', sections.join(','));
        body.set('sections_url', root + 'variants/' + variantId);

        fetch(root + 'cart/add.js', {
          method: 'POST',
          body: body,
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        })
          .then(function (res) {
            // 不直接 .json()：失败时 Shopify 可能回 HTML（429 验证页/challenge），
            // 那样抛的是 `Unexpected token '<'`，看不出哪一步坏了
            return res.text().then(function (text) {
              var json = null;
              try { json = JSON.parse(text); } catch (e) { /* 保持 null */ }
              if (!res.ok || !json) {
                throw new Error(
                  (json && (json.description || json.message)) ||
                  '加购失败（HTTP ' + res.status + '）'
                );
              }
              return json;
            });
          })
          .then(function (json) {
            // 立即购买：加购成功后直接去结账，不弹抽屉
            if (action === 'buy_now') {
              window.location.href = root + 'checkout';
              return;
            }

            if (window.themeVariables &&
                window.themeVariables.settings &&
                window.themeVariables.settings.cartType === 'page') {
              window.location.href = root + 'cart';
              return;
            }

            return fetch(root + 'cart.js')
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                cart.sections = json.sections;
                var items = json.items || [json];
                // variant:add 让 <cart-drawer> 自己 show()；再补一发 cart:change 刷新角标
                card.dispatchEvent(
                  new CustomEvent('variant:add', { bubbles: true, detail: { items: items, cart: cart } })
                );
                document.documentElement.dispatchEvent(
                  new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } })
                );
              });
          })
          .catch(function (err) {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            card.dispatchEvent(
              new CustomEvent('cart:error', { bubbles: true, detail: { error: err.message } })
            );
          })
          .then(function () {
            btn.removeAttribute('aria-busy');
          });
      });
    });
  }

  function initAll(scope) {
    var c = scope || document;
    Array.prototype.forEach.call(c.querySelectorAll('[data-comu-faq]'), initFaq);
    Array.prototype.forEach.call(c.querySelectorAll('[data-comu-vs]'), initVideoShowcase);
    Array.prototype.forEach.call(c.querySelectorAll('[data-comu-pc-card]'), initProductCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
